import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AutoSuggest from 'react-autosuggest';
import uniqBy from 'lodash.uniqby';
import uniq from 'lodash.uniq';

import { Checkbox, Button } from '../../../../components';

const PCPFilter = ({ pcpOptions = [], onSelectedPCPsChanged }) => {
	const [pcpSearchValue, setPCPSearchValue] = useState('');
	const [pcpSuggestions, setPCPSuggestions] = useState([]);
	const [filteredPCPs, setFilteredPCPs] = useState([]);
	const [selectedNPIs, setSelectedNPIs] = useState([]);

	useEffect(() => {
		onSelectedPCPsChanged(selectedNPIs);
	}, [selectedNPIs]);

	const handlePCPSearchChange = (event, { newValue }) => {
		setPCPSearchValue(newValue);
	};

	const handleGetPCPSuggestions = ({ value, /* reason */ }) => {
		const upperValue = `${value}`.toUpperCase();
		const pcpSuggestions = pcpOptions.filter(({ pcp_last_name, pcp_first_name }) => (
			(pcp_last_name.toUpperCase().includes(upperValue) || pcp_first_name.toUpperCase().includes(upperValue))
		)).slice(0, 10);
		setPCPSuggestions(pcpSuggestions);
	};

	const handlePCPSelected = (event, { suggestion }) => {
		event.preventDefault();
		const updatedPCPs = filteredPCPs.slice();
		const updatedNPIs = selectedNPIs.slice();
		updatedPCPs.push(suggestion);
		updatedNPIs.push(suggestion.pcp_npi);
		setFilteredPCPs(uniqBy(updatedPCPs, 'pcp_npi'));
		setSelectedNPIs(uniq(updatedNPIs));
		setPCPSearchValue('');
	};

	const handleNPIToggled = ({ target }) => {
		let updatedNPIs = selectedNPIs.slice();
		if (target.checked) {
			updatedNPIs.push(target.value);
		} else {
			updatedNPIs = updatedNPIs.filter(npi => npi !== target.value);
		}
		setSelectedNPIs(updatedNPIs);
	};

	const handleClearSelections = () => {
		setFilteredPCPs([]);
		setSelectedNPIs([]);
	};

	return (
		<div className="panel panel-primary">
			<div className="panel-heading">PCP Filters</div>
			<div className="panel-body">
				<AutoSuggest
					suggestions={pcpSuggestions}
					onSuggestionsFetchRequested={handleGetPCPSuggestions}
					onSuggestionsClearRequested={() => setPCPSuggestions([])}
					onSuggestionSelected={handlePCPSelected}
					getSuggestionValue={provider => `${provider.pcp_last_name}, ${provider.pcp_first_name}`}
					renderSuggestion={({ pcp_last_name, pcp_first_name }) => (
						<a href="#">{pcp_last_name}, {pcp_first_name}</a>
					)}
					inputProps={{
						placeholder: 'Find PCP',
						onChange: handlePCPSearchChange,
						value: pcpSearchValue
					}}
					theme={{
						container: 'form-group pcp-search',
						suggestionsContainerOpen: 'open',
						input: 'form-control',
						suggestionsList: 'dropdown-menu ml-lg mr-lg'
					}}
				/>
				<div className="selected-pcps">
					{filteredPCPs.map((pcp) => (
						<div key={pcp.pcp_npi}>
							<Checkbox
								checked={selectedNPIs.includes(pcp.pcp_npi)}
								label={`${pcp.pcp_last_name}, ${pcp.pcp_first_name}`}
								onChange={handleNPIToggled}
								value={pcp.pcp_npi}
							/>
						</div>
					))}
				</div>
				{filteredPCPs.length > 0 && (
					<div>
						<Button
							title="Reset PCP Filter"
							onClick={handleClearSelections}
							wide
							small
						/>
					</div>
				)}
			</div>
		</div>
	);
};

PCPFilter.propTypes = {
	pcpOptions: PropTypes.array,
	onSelectedPCPsChanged: PropTypes.func.isRequired
};

export default PCPFilter;
